export default __webpack_public_path__ + "static/media/paypal.9373078f.svg";